'use client';

export const MOBILE_TEAM_MODAL_DEBUG_FEATURE = 'mobile-team-modal-stack';
export const MOBILE_TEAM_MODAL_DEBUG_INSTANCE_ID =
  'mobile-team-modal-stack--2026-06-09';
export const MOBILE_MODAL_DEBUG_PORTAL_ROOT_ID = 'portal-root';
export const MOBILE_MODAL_DEBUG_NO_SNAPSHOT_FINGERPRINT = 'no-snapshot';
const HTML_NAME_ATTRIBUTE = 'name';

export enum MobileModalDebugSource {
  HomePage = 'HomePage',
  ModalStackProvider = 'ModalStackProvider',
  Cstretchmodal = 'Cstretchmodal',
  Csplitmodal = 'Csplitmodal',
  Cteamsmodal = 'Cteamsmodal',
  TeamsModalContent = 'TeamsModalContent',
}

export enum MobileModalDebugShell {
  Stretch = 'stretch',
  Split = 'split',
}

export enum MobileModalDebugDomProbePhase {
  AnimationEvent = 'animation-event',
  Cleanup = 'cleanup',
  Effect = 'effect',
  Interval = 'interval',
  LayoutEffect = 'layout-effect',
  Mutation = 'mutation',
  Raf = 'raf',
  Resize = 'resize',
}

export enum MobileModalDebugName {
  TeamsGallery = 'teams-gallery',
  TeamDetails = 'team-details',
}

export enum MobileModalDebugEvent {
  HomepageModalStateInitialized = 'homepage-modal-state-initialized',
  HomepageModalStateChanged = 'homepage-modal-state-changed',
  PostLoginIntentCheck = 'post-login-intent-check',
  PostLoginPreflightTeamRestored = 'post-login-preflight-team-restored',
  PostLoginOpenNewTeam = 'post-login-open-new-team',
  PostLoginOpenTeamCrafter = 'post-login-open-team-crafter',
  /** The landing hero's Quick Start and the gallery's Quick Start card — the
   *  Team Crafter's create entrances (gate-before-open, like Build). */
  LandingQuickStart = 'landing-quick-start',
  AllTeamsClickOpenGallery = 'all-teams-click-open-gallery',
  TeamsGalleryCloseRequested = 'teams-gallery-close-requested',
  TeamsGalleryBuildYourOwn = 'teams-gallery-build-your-own',
  OpenPreflightForTeam = 'open-preflight-for-team',
  OpenTeamDetailsRequested = 'open-team-details-requested',
  OpenTeamDetailsStateSettersCalled = 'open-team-details-state-setters-called',
  TeamDetailsCloseRequested = 'team-details-close-requested',
  CloseTeamDetailsAndOpenAuth = 'close-team-details-and-open-auth',
  TeamDetailsHandlerEntered = 'team-details-handler-entered',
  TeamDetailsDeploy = 'team-details-deploy',
  TeamDetailsSaveCopy = 'team-details-save-copy',
  ReplicateTeamSaveCopy = 'replicate-team-save-copy',
  ReplicateTeamSaveCopySettled = 'replicate-team-save-copy-settled',
  TeamDetailsEdit = 'team-details-edit',
  TeamDetailsRemove = 'team-details-remove',
  DeleteTeam = 'delete-team',
  DeleteTeamSettled = 'delete-team-settled',
  TeamDetailsQuickStart = 'team-details-quick-start',
  QuickStartCreateSession = 'quick-start-create-session',
  QuickStartCreateSessionSettled = 'quick-start-create-session-settled',
  ReplicateTeamFromSessionHistory = 'replicate-team-from-session-history',
  TeamsGalleryLoginRequest = 'teams-gallery-login-request',
  ViewTeamUrlRestore = 'view-team-url-restore',
  DeployTeamUrlRestore = 'deploy-team-url-restore',
  ModalStackRegister = 'modal-stack-register',
  ModalStackMarkClosing = 'modal-stack-mark-closing',
  ModalStackUnregister = 'modal-stack-unregister',
  ModalStackPush = 'modal-stack-push',
  ModalStackPop = 'modal-stack-pop',
  ModalStackCloseN = 'modal-stack-close-n',
  ModalStackCloseAll = 'modal-stack-close-all',
  ModalStackResolveToDepth = 'modal-stack-resolve-to-depth',
  StretchModalCloseRequested = 'stretch-modal-close-requested',
  StretchModalDomFrame = 'stretch-modal-dom-frame',
  StretchModalDomInterval = 'stretch-modal-dom-interval',
  StretchModalDomMutation = 'stretch-modal-dom-mutation',
  StretchModalDomAnimationEvent = 'stretch-modal-dom-animation-event',
  StretchModalDomResize = 'stretch-modal-dom-resize',
  StretchModalDomProbeLifecycle = 'stretch-modal-dom-probe-lifecycle',
  StretchModalStateInitialized = 'stretch-modal-state-initialized',
  StretchModalStateChanged = 'stretch-modal-state-changed',
  StretchModalEscapeKey = 'stretch-modal-escape-key',
  SplitModalCloseRequested = 'split-modal-close-requested',
  SplitModalBackdropClose = 'split-modal-backdrop-close',
  SplitModalDomFrame = 'split-modal-dom-frame',
  SplitModalDomInterval = 'split-modal-dom-interval',
  SplitModalDomMutation = 'split-modal-dom-mutation',
  SplitModalDomAnimationEvent = 'split-modal-dom-animation-event',
  SplitModalDomResize = 'split-modal-dom-resize',
  SplitModalDomProbeLifecycle = 'split-modal-dom-probe-lifecycle',
  SplitModalStateInitialized = 'split-modal-state-initialized',
  SplitModalStateChanged = 'split-modal-state-changed',
  SplitModalEscapeKey = 'split-modal-escape-key',
  TeamsModalStateInitialized = 'teams-modal-state-initialized',
  TeamsModalStateChanged = 'teams-modal-state-changed',
  TeamsModalBuildYourOwn = 'teams-modal-build-your-own',
  TeamsModalTeamSelect = 'teams-modal-team-select',
  TeamsGalleryCoverageChanged = 'teams-gallery-coverage-changed',
  TeamsContentCarouselRef = 'teams-content-carousel-ref',
  TeamsContentCarouselRefResolved = 'teams-content-carousel-ref-resolved',
  TeamsContentCarouselRefPollCleanup = 'teams-content-carousel-ref-poll-cleanup',
  TeamsContentMotionSuspension = 'teams-content-motion-suspension',
  TeamsContentMotionCategory = 'teams-content-motion-category',
  TeamsContentCarouselUnsubscribe = 'teams-content-carousel-unsubscribe',
  TeamsContentCenteredCategory = 'teams-content-centered-category',
  TeamsContentStateInitialized = 'teams-content-state-initialized',
  TeamsContentStateChanged = 'teams-content-state-changed',
  TeamsContentSearchToggle = 'teams-content-search-toggle',
  TeamsContentEmptyCategoryAutoscroll = 'teams-content-empty-category-autoscroll',
  TeamsContentNavPrevious = 'teams-content-nav-previous',
  TeamsContentNavNext = 'teams-content-nav-next',
  TeamsContentCollectionFilter = 'teams-content-collection-filter',
  TeamsContentOwnedFilter = 'teams-content-owned-filter',
  TeamDetailsCloseRemovePopover = 'team-details-close-remove-popover',
  TeamDetailsOpenRemovePopover = 'team-details-open-remove-popover',
  TeamDetailsEliminateConfirm = 'team-details-eliminate-confirm',
  TeamDetailsStateInitialized = 'team-details-state-initialized',
  TeamDetailsStateChanged = 'team-details-state-changed',
  TeamDetailsQuery = 'team-details-query',
  TeamDetailsDeployClick = 'team-details-deploy-click',
  TeamDetailsEditClick = 'team-details-edit-click',
  TeamDetailsSaveCopyClick = 'team-details-save-copy-click',
  TeamDetailsRemoveClick = 'team-details-remove-click',
  TeamDetailsQuickStartClick = 'team-details-quick-start-click',
  Show6DeployClick = 'show6-deploy-click',
  Show6EditClick = 'show6-edit-click',
  Show6SaveCopyClick = 'show6-save-copy-click',
  Show6SaveCopySettled = 'show6-save-copy-settled',
  Show6ShowSavedCopyClick = 'show6-show-saved-copy-click',
  Show6RemoveArm = 'show6-remove-arm',
  Show6RemoveCancel = 'show6-remove-cancel',
  Show6RemoveConfirm = 'show6-remove-confirm',
  Show6RemoveSettled = 'show6-remove-settled',
  Show6QuickStartClick = 'show6-quick-start-click',
  Show6QuickStartSettled = 'show6-quick-start-settled',
  Show6BuildYourOwn = 'show6-build-your-own',
  Show6CollectionFilter = 'show6-collection-filter',
  Show6LoginRequest = 'show6-login-request',
  Show6PreflightOpened = 'show6-preflight-opened',
  Show6PreflightClosed = 'show6-preflight-closed',
  Show6PreflightLoadTeam = 'show6-preflight-load-team',
  Show6PreflightStartSession = 'show6-preflight-start-session',
  Show6PreflightSaveTemplate = 'show6-preflight-save-template',
  Show6PreflightUpdateTemplate = 'show6-preflight-update-template',
  Show6TeamExpandRequested = 'show6-team-expand-requested',
  Show6CoverageChanged = 'show6-coverage-changed',
}

export enum MobileModalDebugBranch {
  None = 'none',
  AuthNotReady = 'auth-not-ready',
  OpenPreflight = 'open-preflight',
  OpenNewTeam = 'open-new-team',
  OpenTeamCrafter = 'open-team-crafter',
  OpenAuth = 'open-auth',
  OpenTeamDetails = 'open-team-details',
  Expand = 'expand',
  Collapse = 'collapse',
  CloseGalleryAndAuth = 'close-gallery-and-auth',
  DetailsAuthOnly = 'details-auth-only',
  IgnoredBusyOrSaved = 'ignored-busy-or-saved',
  StartSaveCopy = 'start-save-copy',
  IgnoredRemoving = 'ignored-removing',
  StartRemove = 'start-remove',
  IgnoredLoading = 'ignored-loading',
  StartSession = 'start-session',
  NoQueryParam = 'no-query-param',
  MissingId = 'missing-id',
  AlreadyClosing = 'already-closing',
  MissingTarget = 'missing-target',
  CoveredByDetails = 'covered-by-details',
  InteractiveGallery = 'interactive-gallery',
  TargetEntryEmpty = 'target-entry-empty',
  NonPositiveCount = 'non-positive-count',
  AlreadyAtOrBelowTarget = 'already-at-or-below-target',
  Ignored = 'ignored',
  Close = 'close',
  PollForRef = 'poll-for-ref',
  SubscribeMotionValue = 'subscribe-motion-value',
  SameIndex = 'same-index',
  TriggerAlreadyHandled = 'trigger-already-handled',
  NoCategories = 'no-categories',
  CurrentCategoryHasTeams = 'current-category-has-teams',
  AllCategoriesEmpty = 'all-categories-empty',
  NearestCategorySameOrMissing = 'nearest-category-same-or-missing',
  LoginRequired = 'login-required',
  MissingCallback = 'missing-callback',
  Disabled = 'disabled',
  Remove = 'remove',
  MissingTeamId = 'missing-team-id',
  MissingAnchor = 'missing-anchor',
  OpenEditPreflight = 'open-edit-preflight',
}

export interface MobileModalDomRectSnapshot {
  bottom: number;
  height: number;
  left: number;
  right: number;
  top: number;
  width: number;
  x: number;
  y: number;
}

export interface MobileModalDomStyleSnapshot {
  backdropFilter: string;
  backgroundColor: string;
  backgroundImage: string;
  display: string;
  filter: string;
  opacity: string;
  overflow: string;
  pointerEvents: string;
  position: string;
  transform: string;
  transitionDuration: string;
  transitionProperty: string;
  visibility: string;
  zIndex: string;
}

export interface MobileModalDomElementSnapshot {
  childElementCount: number;
  className: string | null;
  clientHeight: number;
  clientWidth: number;
  dataName: string | null;
  debugName: string | null;
  displayTextLength: number;
  id: string | null;
  index: number;
  modalId: string | null;
  rect: MobileModalDomRectSnapshot;
  role: string | null;
  scrollHeight: number;
  scrollLeft: number;
  scrollTop: number;
  scrollWidth: number;
  shell: string | null;
  style: MobileModalDomStyleSnapshot;
  tagName: string;
}

export interface MobileModalDomSnapshot {
  allDebugNames: string[];
  bodyChildElementCount: number;
  elements: MobileModalDomElementSnapshot[];
  environment: MobileModalEnvironmentSnapshot | null;
  matchingElementCount: number;
  modalId: string | null;
  portalRootChildElementCount: number | null;
  portalRootExists: boolean;
  portalRootRect: MobileModalDomRectSnapshot | null;
  trackedElementCount: number;
}

function roundDomNumber(value: number): number {
  return Math.round(value * 100) / 100;
}

function readRect(rect: DOMRect): MobileModalDomRectSnapshot {
  return {
    bottom: roundDomNumber(rect.bottom),
    height: roundDomNumber(rect.height),
    left: roundDomNumber(rect.left),
    right: roundDomNumber(rect.right),
    top: roundDomNumber(rect.top),
    width: roundDomNumber(rect.width),
    x: roundDomNumber(rect.x),
    y: roundDomNumber(rect.y),
  };
}

function trimCssValue(value: string, maxLength = 180): string {
  if (value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, maxLength)}...`;
}

export function captureMobileModalDomElementSnapshot(
  element: HTMLElement,
  index: number,
): MobileModalDomElementSnapshot {
  const computedStyle = window.getComputedStyle(element);
  const rect = element.getBoundingClientRect();

  return {
    childElementCount: element.childElementCount,
    className: element.className || null,
    clientHeight: element.clientHeight,
    clientWidth: element.clientWidth,
    dataName: element.dataset.name ?? null,
    debugName: null,
    displayTextLength: element.textContent?.length ?? 0,
    id: element.id || null,
    index,
    modalId: null,
    rect: readRect(rect),
    role: null,
    scrollHeight: element.scrollHeight,
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop,
    scrollWidth: element.scrollWidth,
    shell: null,
    style: {
      backdropFilter: trimCssValue(
        computedStyle.getPropertyValue('backdrop-filter') ||
          computedStyle.getPropertyValue('-webkit-backdrop-filter'),
      ),
      backgroundColor: computedStyle.backgroundColor,
      backgroundImage: trimCssValue(computedStyle.backgroundImage),
      display: computedStyle.display,
      filter: trimCssValue(computedStyle.filter),
      opacity: computedStyle.opacity,
      overflow: computedStyle.overflow,
      pointerEvents: computedStyle.pointerEvents,
      position: computedStyle.position,
      transform: trimCssValue(computedStyle.transform),
      transitionDuration: computedStyle.transitionDuration,
      transitionProperty: trimCssValue(computedStyle.transitionProperty),
      visibility: computedStyle.visibility,
      zIndex: computedStyle.zIndex,
    },
    tagName: element.tagName,
  };
}

export function captureMobileModalDomSnapshot({
  modalId,
}: {
  modalId?: string | null;
}): MobileModalDomSnapshot | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const allTrackedElements: HTMLElement[] = [];
  const portalRoot = document.getElementById(MOBILE_MODAL_DEBUG_PORTAL_ROOT_ID);

  return {
    allDebugNames: [],
    bodyChildElementCount: document.body.childElementCount,
    elements: allTrackedElements.map(captureMobileModalDomElementSnapshot),
    environment: captureMobileModalEnvironment(),
    matchingElementCount: 0,
    modalId: modalId ?? null,
    portalRootChildElementCount: portalRoot?.childElementCount ?? null,
    portalRootExists: Boolean(portalRoot),
    portalRootRect: portalRoot
      ? readRect(portalRoot.getBoundingClientRect())
      : null,
    trackedElementCount: allTrackedElements.length,
  };
}

export function createMobileModalDomFingerprint(
  snapshot: MobileModalDomSnapshot | null,
): string {
  if (!snapshot) {
    return MOBILE_MODAL_DEBUG_NO_SNAPSHOT_FINGERPRINT;
  }

  const elementFingerprints = snapshot.elements.map((element) => [
    element.debugName,
    element.shell,
    element.role,
    element.modalId,
    element.rect.left,
    element.rect.top,
    element.rect.width,
    element.rect.height,
    element.style.opacity,
    element.style.transform,
    element.style.display,
    element.style.visibility,
    element.style.zIndex,
    element.style.backdropFilter,
  ].join(':'));

  return [
    snapshot.portalRootChildElementCount,
    snapshot.trackedElementCount,
    snapshot.environment?.windowInnerWidth,
    snapshot.environment?.windowInnerHeight,
    snapshot.environment?.visualViewportWidth,
    snapshot.environment?.visualViewportHeight,
    snapshot.environment?.bodyOverflow,
    ...elementFingerprints,
  ].join('|');
}

export interface MobileModalEnvironmentSnapshot {
  capturedAtMs: number;
  windowInnerWidth: number;
  windowInnerHeight: number;
  visualViewportWidth: number | null;
  visualViewportHeight: number | null;
  visualViewportOffsetTop: number | null;
  visualViewportOffsetLeft: number | null;
  visualViewportScale: number | null;
  scrollX: number;
  scrollY: number;
  bodyOverflow: string | null;
  bodyPosition: string | null;
  bodyZoom: string | null;
  activeElementTag: string | null;
  activeElementName: string | null;
  documentHidden: boolean;
}

const EMPTY_MOBILE_MODAL_VISUAL_VIEWPORT = {
  visualViewportWidth: null,
  visualViewportHeight: null,
  visualViewportOffsetTop: null,
  visualViewportOffsetLeft: null,
  visualViewportScale: null,
};

function captureMobileModalVisualViewport() {
  const visualViewport = window.visualViewport;
  if (!visualViewport) return EMPTY_MOBILE_MODAL_VISUAL_VIEWPORT;

  return {
    visualViewportWidth: visualViewport.width,
    visualViewportHeight: visualViewport.height,
    visualViewportOffsetTop: visualViewport.offsetTop,
    visualViewportOffsetLeft: visualViewport.offsetLeft,
    visualViewportScale: visualViewport.scale,
  };
}

function captureMobileModalBodyStyle() {
  if (!document.body) {
    return {
      bodyOverflow: null,
      bodyPosition: null,
      bodyZoom: null,
    };
  }

  const bodyStyle = window.getComputedStyle(document.body);
  return {
    bodyOverflow: bodyStyle.overflow,
    bodyPosition: bodyStyle.position,
    bodyZoom: bodyStyle.zoom,
  };
}

function getActiveElementName(activeElement: Element | null): string | null {
  if (!(activeElement instanceof HTMLElement)) return null;
  return activeElement.getAttribute(HTML_NAME_ATTRIBUTE);
}

export function captureMobileModalEnvironment():
  | MobileModalEnvironmentSnapshot
  | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const activeElement = document.activeElement;

  return {
    capturedAtMs: performance.now(),
    windowInnerWidth: window.innerWidth,
    windowInnerHeight: window.innerHeight,
    ...captureMobileModalVisualViewport(),
    scrollX: window.scrollX,
    scrollY: window.scrollY,
    ...captureMobileModalBodyStyle(),
    activeElementTag: activeElement?.tagName ?? null,
    activeElementName: getActiveElementName(activeElement),
    documentHidden: document.hidden,
  };
}
